$(document).ready(function(){
    $('.featured-collection__slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: '<div class="arrow-left"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 12C7 12.203 7.08232 12.3974 7.22815 12.5387L15.2282 20.2887C15.5257 20.5769 16.0005 20.5693 16.2887 20.2718C16.5769 19.9743 16.5694 19.4995 16.2718 19.2113L8.8279 12L16.2718 4.78868C16.5694 4.50047 16.5769 4.02566 16.2887 3.72815C16.0005 3.43065 15.5257 3.42311 15.2282 3.71132L7.22815 11.4613C7.08232 11.6026 7 11.797 7 12Z" fill="#CECECE"/></svg></div>',
      nextArrow: '<div class="arrow-right"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 12C17 12.203 16.9177 12.3974 16.7718 12.5387L8.77185 20.2887C8.47434 20.5769 7.99953 20.5693 7.71132 20.2718C7.42311 19.9743 7.43065 19.4995 7.72815 19.2113L15.1721 12L7.72815 4.78868C7.43065 4.50047 7.42311 4.02566 7.71132 3.72815C7.99953 3.43065 8.47434 3.42311 8.77185 3.71132L16.7718 11.4613C16.9177 11.6026 17 11.797 17 12Z" fill="#CECECE"/></svg></div>',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 750,
          settings: {
            arrows: false,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            slidesToShow: 1
          }
        }
      ]
    });
    $('.featured-collection__slider').on("beforeChange", function (event, slick, currentSlide, nextSlide){
      var i = nextSlide + 1;
      var id = $(this).data("id");
      $("#featured-collection__line-"+ id +" .line").removeClass("active");
      $("#featured-collection__line-"+ id +" .line:nth-child("+ i +")").addClass("active");
    });
  
  if($(window).width() > 749){
    $('.multicolumn-slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<div class="arrow-left"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 12C7 12.203 7.08232 12.3974 7.22815 12.5387L15.2282 20.2887C15.5257 20.5769 16.0005 20.5693 16.2887 20.2718C16.5769 19.9743 16.5694 19.4995 16.2718 19.2113L8.8279 12L16.2718 4.78868C16.5694 4.50047 16.5769 4.02566 16.2887 3.72815C16.0005 3.43065 15.5257 3.42311 15.2282 3.71132L7.22815 11.4613C7.08232 11.6026 7 11.797 7 12Z" fill="#CECECE"/></svg></div>',
      nextArrow: '<div class="arrow-right"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 12C17 12.203 16.9177 12.3974 16.7718 12.5387L8.77185 20.2887C8.47434 20.5769 7.99953 20.5693 7.71132 20.2718C7.42311 19.9743 7.43065 19.4995 7.72815 19.2113L15.1721 12L7.72815 4.78868C7.43065 4.50047 7.42311 4.02566 7.71132 3.72815C7.99953 3.43065 8.47434 3.42311 8.77185 3.71132L16.7718 11.4613C16.9177 11.6026 17 11.797 17 12Z" fill="#CECECE"/></svg></div>',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 990,
          settings: {
            arrows: false,
            slidesToShow: 1
          }
        }
      ]
    });
    $('.multicolumn-slider').on("beforeChange", function (event, slick, currentSlide, nextSlide){
      var i = nextSlide + 1;
      var id = $(this).data("id");
      $("#multicolumn__line-"+ id +" .line").removeClass("active");
      $("#multicolumn__line-"+ id +" .line:nth-child("+ i +")").addClass("active");
    });
  }

  $(".image-with-note__testimonial-slider").slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<div class="arrow-left"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 12C7 12.203 7.08232 12.3974 7.22815 12.5387L15.2282 20.2887C15.5257 20.5769 16.0005 20.5693 16.2887 20.2718C16.5769 19.9743 16.5694 19.4995 16.2718 19.2113L8.8279 12L16.2718 4.78868C16.5694 4.50047 16.5769 4.02566 16.2887 3.72815C16.0005 3.43065 15.5257 3.42311 15.2282 3.71132L7.22815 11.4613C7.08232 11.6026 7 11.797 7 12Z" fill="#CECECE"/></svg></div>',
      nextArrow: '<div class="arrow-right"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 12C17 12.203 16.9177 12.3974 16.7718 12.5387L8.77185 20.2887C8.47434 20.5769 7.99953 20.5693 7.71132 20.2718C7.42311 19.9743 7.43065 19.4995 7.72815 19.2113L15.1721 12L7.72815 4.78868C7.43065 4.50047 7.42311 4.02566 7.71132 3.72815C7.99953 3.43065 8.47434 3.42311 8.77185 3.71132L16.7718 11.4613C16.9177 11.6026 17 11.797 17 12Z" fill="#CECECE"/></svg></div>'
  });

  $(".product-media-modal__content").slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<div class="arrow-left"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 12C7 12.203 7.08232 12.3974 7.22815 12.5387L15.2282 20.2887C15.5257 20.5769 16.0005 20.5693 16.2887 20.2718C16.5769 19.9743 16.5694 19.4995 16.2718 19.2113L8.8279 12L16.2718 4.78868C16.5694 4.50047 16.5769 4.02566 16.2887 3.72815C16.0005 3.43065 15.5257 3.42311 15.2282 3.71132L7.22815 11.4613C7.08232 11.6026 7 11.797 7 12Z" fill="#CECECE"/></svg></div>',
      nextArrow: '<div class="arrow-right"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 12C17 12.203 16.9177 12.3974 16.7718 12.5387L8.77185 20.2887C8.47434 20.5769 7.99953 20.5693 7.71132 20.2718C7.42311 19.9743 7.43065 19.4995 7.72815 19.2113L15.1721 12L7.72815 4.78868C7.43065 4.50047 7.42311 4.02566 7.71132 3.72815C7.99953 3.43065 8.47434 3.42311 8.77185 3.71132L16.7718 11.4613C16.9177 11.6026 17 11.797 17 12Z" fill="#CECECE"/></svg></div>'
  });

  if($(window).width() <= 749){
    $(".template-search__result-article .product-grid").slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });
  }

  $(".recommended-product__slider").slick({
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });

  $(".top-menu ul li").hover(function(){
    $(this).addClass("active");
    $(this).find(".top-menu__dropdown").addClass("open");
  }, function(){
    $(this).removeClass("active");
    $(this).find(".top-menu__dropdown").removeClass("open");
  });

  // if($(window).width() >= 750){
  //   var h1 = $(".footer__blocks-wrapper .footer-block:nth-child(1)").height();
  //   var h2 = $(".footer__blocks-wrapper .footer-block:nth-child(2)").height();
  //   var h = h1+h2+55;
  //   $(".footer__blocks-wrapper").css("height", h+"px");
  // }

  $('.blog-articles__category select').change( function() {
    location.href = $(this).val();
  });

  document.addEventListener('rebuy.ready', function(event){
    $(".rebuy-button").click(function(){
      setTimeout(function(){
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(cart) {
            $(".cart-count-bubble span[aria-hidden='true']").text(cart.item_count);
          }
        });
      }, 1000);
    });
  }); 

  document.addEventListener('rebuy:cart.change', function(event){
    setTimeout(function(){
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(cart) {
            $(".cart-count-bubble span[aria-hidden='true']").text(cart.item_count);
          }
        });
      }, 1000);
  }); 
});

$(function(){
  $('.popup-with-zoom-anim').magnificPopup({
		type: 'inline',

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: 'auto',

		closeBtnInside: true,
		preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in',

        callbacks: {
          open: function() {
            $('body').css('overflow', 'hidden');
            $(".mfp-close").click(function(e){
              e.stopPropagation();
              $.magnificPopup.close();
            });
          },
          close: function() {
            $('body').css('overflow', '');
          }
        }
  });
});

$(document).ready(function () {
  setTimeout(function() {
    if ($('#age-verification-popup').length && $.cookie('over-21') != 'true') {
       $.magnificPopup.open({
        items: {
            src: '#age-verification-popup' 
        },
        type: 'inline',
        closeOnBgClick: false,
        callbacks: {
          open: function() {
            $("#age-verification-popup .btn-over").click(function(e){
              e.stopPropagation();
              $.cookie('over-21', 'true', { expires: 7 });
              $.magnificPopup.close();
            });
          }
        }
      });
   }
  }, 1000);
});

$(".facet-layouts__field").click(function(){
    $.session.remove('layout');
    var layout = $(this).data("layout");
    $(".facet-layouts__field").removeClass("active");
    $(this).addClass("active");
    if(layout == 'grid'){
      $.session.set('layout', 'grid');
      $(".product-grid__grid").show();
      $(".product-grid__list").hide();
    }else{
      $.session.set('layout', 'list');
      $(".product-grid__grid").hide();
      $(".product-grid__list").show();
    }
  });

$(".quick-add .qty-minus").click(function(){
  var x = $(this).parent().find("input").val();
  if(x > 1){
    $(this).parent().find("input").val(parseInt(x) - 1);
  }
});
$(".quick-add .qty-plus").click(function(){
  var x = $(this).parent().find("input").val();
  $(this).parent().find("input").val(parseInt(x) + 1);
});

$(".recommended-products__item-quantity .qty-minus").click(function(){
  var x = $(this).parent().find("input").val();
  if(x > 1){
    $(this).parent().find("input").val(parseInt(x) - 1);
  }
});
$(".recommended-products__item-quantity .qty-plus").click(function(){
  var x = $(this).parent().find("input").val();
  $(this).parent().find("input").val(parseInt(x) + 1);
});

$(".btn-readmore").click(function(){
  $(this).parent().toggleClass("open");
  var text = $(this).text();
    $(this).text(
        text == "Read More" ? "Read Less" : "Read More");
});

$(".rangeslider input").change(function(){
  var min = $(this).parent().find('.min').val();
  var max = $(this).parent().find('.max').val();
  $(this).parent().find('.range_min').html('$'+min);
  $(this).parent().find('.range_max').html('$'+max);
});

$("#toTop").click(function () {
   $("html, body").animate({scrollTop: 0}, 1000);
});

$(".cart__age-check svg").click(function(){
  $(this).parent().find("input").prop("checked", false);
});
$(".cart__age-check input, .cart__age-check svg").click(function(){
  $.removeCookie('age-check');
  if($(this).is(':checked')){
    $.cookie('age-check', 'checked', { expires: 1 });
  }else{
    $.cookie('age-check', 'unchecked', { expires: 1 });
  }
});
$(document).ready(function() {
  console.log($.cookie('age-check'));
  if($.cookie('age-check') == 'checked'){
    $(".CartPage__age-check input[name='age-check']").prop("checked", true);
    $(".CartDrawer__age-check input[name='age-check']").prop("checked", true);
  }else{
    $(".CartPage__age-check input[name='age-check']").prop("checked", false);
    $(".CartDrawer__age-check input[name='age-check']").prop("checked", false);
  }
});
$('body').on('click', '.age-verification[name="checkout"]', function() {
  var form = $(this).attr('form');
  if(form == 'cart'){   
    var cart = '.CartPage__age-check';
  }else{
    var cart = '.CartDrawer__age-check';
  }
      var x = $('.cart__age-check').attr('data-alert');
      if ($(cart+' #age-check').is(':checked')) {
        $(this).submit();
      }else {
        alert(x);
        return false;
      }
});

$(".faq__accordion-title").click(function(){
  $(this).parent().toggleClass("active");
  $(this).parent().find(".faq__accordion-text").slideToggle();
});

$(function () {
    $(".iwtc__wrapper .iwtc__item").slice(0, 8).show();
    $(".iwtc__btn-more .button").on('click', function (e) {
        e.preventDefault();
        $(".iwtc__wrapper .iwtc__item:hidden").slice(0, 8).slideDown();
        if ($(".iwtc__wrapper .iwtc__item:hidden").length == 0) {
            $(".iwtc__btn-more").fadeOut('slow');
        }
    });
});

$(document).ready(function() {
    $('#create_customer button').click(function() {
      var email = $("#RegisterForm-email").val();
      var cemail = $("#RegisterForm-confirm-email").val();
      var pw = $("#RegisterForm-password").val();
      var cpw = $("#RegisterForm-confirm-password").val();
      if (email == cemail) {
        if (pw == cpw) {
          $(this).submit();
        }else{
          alert("Password don't match!");
          return false;
        }
      }else {
        alert("Email don't match!");
        return false;
      }
    });
  });

$(".shipping-info-popup").click(function(){
  if ($('#shipping-information').length) {
    $.magnificPopup.open({
      items: {
        src: '#shipping-information' 
      },
      type: 'inline',
      callbacks: {
          open: function() {
            $(".shipping-information__title svg").click(function(){
              $.magnificPopup.close();
            });
            $('body').css('overflow', 'hidden');
          },
        close: function() {                       
            $('body').css('overflow', '');    
        }
      }
    });
  }
});

$(".page-team__member .member-link").click(function(){
  $(this).parents(".member-info").find(".member-about").toggle();
  var text = $(this).text();
    $(this).text(
        text == "About" ? "Close" : "About");
});

$("a.button").click(function(){
  $(this).addClass("active");
});

$(".cart__age-checkbox").click(function(){
  if($(this).find("input").is(':checked')){
    $(this).addClass("active");
  }else{
    $(this).removeClass("active");
  }
});

$('.customer .input-password .icon').click(function(){
  var v = $(this).parent().find('input').val();
  if(v != ''){
    $(this).hide();
    if('password' == $(this).parent().find('input').attr('type')){
         $(this).parent().find('input').prop('type', 'text');
         $(this).parent().find('.icon-eye-closed').show();
    }else{
         $(this).parent().find('input').prop('type', 'password');
         $(this).parent().find('.icon-eye-open').show();
    }
  }
});

$(".facets-vertical__icon").click(function(){
  if($(window).width() > 749){
    $(this).parents(".facets").addClass("facets-vertical__open");
    $("#ProductGridContainer").removeClass("no-filters");
  }else{
    $(".mobile-facets__open-wrapper").trigger("click");
  }
});
$(".active-facets__button-remove-all").click(function(){
  $(".facets").removeClass("facets-vertical__open");
  $("#ProductGridContainer").addClass("no-filters");
});

$(".image-with-note__text-title").click(function(){
  $(this).parent().toggleClass("active");
});

$(".mobile-facets__summary").click(function(){
  $(this).parent().toggleClass("active");
  $(this).parent().find(".mobile-facets__submenu").slideToggle();
});

function goToByScroll(id) {
    id = id.replace("link", "");
    $('html,body').animate({
        scrollTop: $("#" + id).offset().top - 30
    }, 'slow');
}

$(".faq__navigation select").change(function(){
  var id = $(this).val();
  goToByScroll(id);
});

$(".search__input, .field__input, .customer .field input").on("change keypress keydown keyup", function(e){
  if($(this).val() != ''){
    $(this).addClass('active');
  }else{
    $(this).removeClass('active');
  }
});

// $(".blog-articles__category-label").click(function(){
//   $(this).parents(".blog-articles__category").toggleClass("active");
// });

$(".blog-articles__category").click(function(){
  $(this).toggleClass("active");
});

$(".blog-articles__category-list ul li").click(function(){
  $(this).addClass("active");
});

$(".customer .field .icon-close-input").click(function(){
  $(this).parent().find("input").val("").removeClass("active");
  $(this).parent().find('input').prop('type', 'password');
});

$(".facets__display-vertical .rangeslider-wrapper .rangeslider input").change(function(){
  var x = $(".facets__display-vertical .rangeslider .min").attr("max");
  var min = $(".facets__display-vertical .rangeslider .min").val();
  var max = $(".facets__display-vertical .rangeslider .max").val();
  var min_percent = min/(x/100);
  var max_percent = (x-max)/(x/100);
  $('head').append('<style>.facets__display-vertical .rangeslider.active:before{width:'+min_percent+'% !important;}.facets__display-vertical .rangeslider.active:after{width:'+max_percent+'% !important;}</style>');
  $(this).parent().addClass("active");
});

$(".mobile-facets__submenu .rangeslider-wrapper .rangeslider input").change(function(){
  var x = $(".mobile-facets__submenu .rangeslider .min").attr("max");
  var min = $(".mobile-facets__submenu .rangeslider .min").val();
  var max = $(".mobile-facets__submenu .rangeslider .max").val();
  var min_percent = min/(x/100);
  var max_percent = (x-max)/(x/100);
  $('head').append('<style>.mobile-facets__submenu .rangeslider.active:before{width:'+min_percent+'% !important;}.mobile-facets__submenu .rangeslider.active:after{width:'+max_percent+'% !important;}</style>');
  $(this).parent().addClass("active");
});

$(".EditFormButton").click(function(){
  var id = $(this).data("address-id");
  $("#AddAddress").hide();
  $(".EditAddressForm").hide();
  $("#EditAddress_"+id).show();
});
$(".EditAddressForm button[type='reset']").click(function(){
  $(".EditAddressForm").hide();
  $("#AddAddress").hide();
});
$(".AddAddressButton").click(function(){
  $(".EditAddressForm").hide();
  $("#AddAddress").toggle();
});

$(function(){
  if($(window).width() > 749){
      $(".facets-vertical__icon svg").trigger("click");
  }
});

$(".facet-filters__field .select").click(function(){
  $(this).toggleClass("open");
  $(this).find(".select-options").toggle();
});
$(".facet-filters__sort-select .select-options li").click(function(){
  var v = $(this).data("value");
  $(this).parents("form").find("select[name='sort_by']").val(v).trigger("change");
  var url = $(location).attr('href');
  var pathname = $(location).attr('pathname');
  var i = url.indexOf("&");
  var element = url.substring(i);
  if(i > -1){
    window.location.href = pathname + '?sort_by=' + v + element;
  }else{
    window.location.href = pathname + '?sort_by=' + v;
  }
});
$(document).ready(function(){
  if($(window).width() > 749){
    $(".facet-filters__field.medium-hide select[name='sort_by']").prop("disabled", true);
    $(".facet-filters__field.small-hide select[name='sort_by']").prop("disabled", false);
  }else{
    $(".facet-filters__field.medium-hide select[name='sort_by']").prop("disabled", false);
    $(".facet-filters__field.small-hide select[name='sort_by']").prop("disabled", true);
  }
});
$(document).mouseup(function(e) {
    var container = $(".facet-filters__field .select");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass("open");
        container.find(".select-options").hide();
    }

    var country = $(".top-menu ul li");
    if (!country.is(e.target) && country.has(e.target).length === 0) {
        country.removeClass("active");
        country.find(".top-menu__dropdown").removeClass("open");
    }
});

$(".faq__navigation-mobile").click(function(){
  $(this).toggleClass("open");
  $(this).find("ul").toggle();
});
$(".faq__navigation-mobile ul li").click(function(){
  $(".faq__navigation-mobile ul li").removeClass("active");
  $(this).addClass("active");
  var v = $(this).data("value");
  goToByScroll(v);
  var title = $(this).text();
  $(".faq__navigation label").text(title);
});

$(".card__wishlist").click(function(){
  return false;
});

$(".page-az__producer .page-az__item h4, .page-az__grape .page-az__item h4").click(function(){
    $(this).parent().toggleClass("open");
});

$(".search .reset__button").click(function(){
  window.location.href = '/search';
});